import { ReactNode } from 'react';

import Button from './Button';
import Modal from './Modal';
import { useTranslation } from 'src/i18n/client';

type Props = {
    open: boolean;
    title: ReactNode;
    message: ReactNode;
    buttonVariant?: 'danger' | 'primary' | 'secondary';
    loading?: boolean;
    onNo: () => any;
    onYes: () => any;
};

export default function ConfirmDialog(props: Props) {
    const { t } = useTranslation(null, 'common');
    const performIfDefined = (action: any) => {
        if (action) {
            action();
        }
    };

    const { open, title, message, buttonVariant, onNo, onYes } = props;

    return (
        <Modal
            size="md"
            show={open}
            onClose={onNo}
            title={<div className="text-primary font-display p-4 pb-0 text-2xl md:px-6">{title}</div>}>
            <div className="p-4 md:p-6">
                {message}
                <div className="mt-4 flex justify-center gap-4">
                    <Button
                        variant="default"
                        onClick={() => {
                            performIfDefined(onNo);
                        }}>
                        {t('labels.no')}
                    </Button>
                    <Button
                        disabled={props.loading}
                        variant={buttonVariant || 'danger'}
                        onClick={() => {
                            performIfDefined(onYes);
                        }}>
                        {t('labels.yes')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
